import React from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { Box, Typography, Paper } from '@material-ui/core'
import LockIcon from '@material-ui/icons/Lock'

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
    },
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '3rem',
      maxWidth: '500px',
      textAlign: 'center',
    },
    iconContainer: {
      backgroundColor: '#ffebee',
      borderRadius: '50%',
      padding: '1.5rem',
      marginBottom: '1.5rem',
    },
    icon: {
      fontSize: '3rem',
      color: '#d32f2f',
    },
    title: {
      marginBottom: '1rem',
      fontWeight: 600,
      color: '#333',
    },
    message: {
      marginBottom: '1.5rem',
      color: '#666',
      lineHeight: 1.6,
    },
    helpText: {
      fontSize: '0.875rem',
      color: '#999',
    },
  })
)

interface SecureBrowserAccessDeniedProps {
  clientID?: number
}

const SecureBrowserAccessDenied: React.FC<SecureBrowserAccessDeniedProps> = ({ clientID }) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} elevation={2}>
        <Box className={classes.iconContainer}>
          <LockIcon className={classes.icon} />
        </Box>
        <Typography variant="h2" className={classes.title}>
          Access Restricted
        </Typography>
        <Typography className={classes.message}>
          This order{clientID ? ` (#${clientID})` : ''} requires access through AWS Secure Browser. Please open AWS
          Secure Browser and navigate to this page to view the order details.
        </Typography>
        <Typography className={classes.helpText}>
          If you believe you should have access, please contact your administrator.
        </Typography>
      </Paper>
    </Box>
  )
}

export default SecureBrowserAccessDenied
